import './api/interceptors';
import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

import AppProviders from './AppProviders';
import ScrollTop from './components/_shared/ScrollTop';
import chatOverride from './components/_shared/styles/chatOverride';
import * as fonts from './index.css';
import Routes from './Routes';
import { initializeDataDog } from './utilities/dataDog';
import initPerfume from './utilities/perfume';

const GlobalStyle = createGlobalStyle`
  ${reset}
  ${fonts}
  ${chatOverride}
`;

initPerfume();
initializeDataDog();

const App = () => (
  <AppProviders>
    <ScrollTop />
    <Routes />
    <GlobalStyle />
  </AppProviders>
);

export default App;
